<template>
  <span class="d-inline-flex align-center flex-wrap" style="gap: 6px">
    <v-btn small outlined color="error" :disabled="working" @click="rejection = { open: true, reason: '' }">{{ $t('onboarding.registration.approval.reject') }}</v-btn>
    <v-btn small color="success" :loading="working" @click="approve">{{ $t('onboarding.registration.approval.approve') }}</v-btn>

    <!-- Refuser s'explique : le motif part à la personne. -->
    <v-dialog v-model="rejection.open" max-width="520">
      <v-card>
        <v-card-title>{{ $t('onboarding.registration.approval.reject') }}</v-card-title>
        <v-card-text>
          <p class="text-caption">{{ $t('onboarding.registration.approval.reason-explained') }}</p>
          <v-textarea v-model="rejection.reason" :label="$t('onboarding.registration.approval.reason')" outlined rows="3" auto-grow autofocus />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn small text @click="rejection.open = false">{{ $t('cancel') }}</v-btn>
          <v-btn small color="error" :loading="working" :disabled="!rejection.reason.trim()" @click="reject">{{ $t('onboarding.registration.approval.reject') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import RegistrationRepository from '@repository/RegistrationRepository'

/**
 * Valider ou refuser une inscription venue par un lien d'invitation : le même geste dans le dossier et dans la file.
 * Refuser demande le motif, envoyé à la personne. Annonce la décision (`decided`) ; l'écran relit ce qu'il montre.
 */
export default {
  name: 'RegistrationApprovalActions',

  props: {
    registrationId: { type: String, required: true },
    // Le nom et l'organisation, pour confirmer sans le dossier sous les yeux (depuis une ligne de la file).
    confirmWith: { type: Object, default: null },
  },

  data() {
    return { working: false, rejection: { open: false, reason: '' } }
  },

  methods: {
    async approve() {
      if (this.confirmWith && !(await this.$dialog.confirm({
        title: this.$t('onboarding.registration.approval.approve-title'),
        text: this.$t('onboarding.registration.approval.approve-text', this.confirmWith),
      }))) return
      await this.decide(true)
    },

    async reject() {
      if (await this.decide(false, this.rejection.reason.trim())) this.rejection = { open: false, reason: '' }
    },

    async decide(approved, reason = null) {
      this.working = true
      try {
        await RegistrationRepository.decideApproval(this.registrationId, approved, reason)
        this.notifySuccess(approved ? 'onboarding.registration.approval.approved-ok' : 'onboarding.registration.approval.rejected-ok')
        this.$emit('decided', approved)
        return true
      } catch (e) {
        this.notifyError(e)
        return false
      } finally {
        this.working = false
      }
    },
  },
}
</script>
